import React from 'react';
import { BrowserRouter } from 'react-router-dom';


import GlobalStyle from './styles/global';

import Routes from './routes';

const App: React.FC = () => (
  <>
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
    <GlobalStyle />
  </>

)


export default App;


// import React from 'react';
// import { BrowserRouter } from 'react-router-dom';

// import Routes from './routes';

// const App: React.FC = () =>  (
//   <BrowserRouter>
//     <Routes />
//   </BrowserRouter>
// );

// export default App;
